// Element
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import locale from "element-ui/lib/locale/lang/zh-CN" // lang i18n

// flex 布局库
import "flex.css"
// 组件
import "@/components"
// svg 图标
import "@/assets/svg-icons"
// 功能插件
import pluginError from "@/plugin/error"
import pluginLog from "@/plugin/log"
import pluginOpen from "@/plugin/open"
import pluginPermission from "@/plugin/permission"

export default {
  async install(Vue, options) {
    // 设置为 false 以阻止 vue 在启动时生成生产提示。https://cn.vuejs.org/v2/api/#productionTip
    Vue.config.productionTip = false
    // 当前环境
    Vue.prototype.$env = process.env.NODE_ENV
    // 当前的 baseUrl
    Vue.prototype.$baseUrl = process.env.BASE_URL
    // Element
    Vue.use(ElementUI, { locale })
    // Vue.use(ElementUI)
    // 插件
    Vue.use(pluginError)
    Vue.use(pluginLog)
    Vue.use(pluginOpen)
    Vue.use(pluginPermission, options)
  }
}
